import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { COMPANIES_ROUTE } from '../shared/constants/routes';
import { CompaniesComponent } from './companies/companies.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: COMPANIES_ROUTE,
    component: CompaniesComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompaniesRoutingModule {}
